export const questions: {
  [key: string]: { text: string; options: string[] };
} = {
  1: {
    text: "Как называлась локация, где проходила церемония?",
    options: [
      "Березовая аллея",
      'Парк "Беларусь"',
      "Зелёная роща",
      "Фруктовый сад",
    ],
  },
  2: {
    text: "Сколько весила кувалда?",
    options: ["1 кг", "3 кг", "5 кг", "10 кг"],
  },
  3: {
    text: "Кому больше всего понравилась мясная нарезка?",
    options: ["Гостям", "Лизе", "Осам", "Поварам"],
  },
  4: {
    text: "Что забыли привезти к столу?",
    options: ["Нож для торта", "Вилки", "Рюмки", "Чайные ложки"],
  },
  5: {
    text: "В каком оттенке были женские наряды?",
    options: ["Пудровая роза", "Дачная роза", "Нежная свёкла", "Чайная роза"],
  },
  6: {
    text: "Где взяли пень для монетного пресса?",
    options: [
      "Украли с лесопилки",
      "Нашли в парке на Управленческом",
      "Купили у таксиста",
      "Заказали на Озоне",
    ],
  },
  7: {
    text: "Что оказалось самой загадочной частью тела?",
    options: ["Пупок", "Зрачок", "Коленная чашечка", "Хрящик"],
  },
  8: {
    text: "Откуда приехал монетный пресс?",
    options: ["Из Омска", "Из Томска", "Из Анапы", "Из Самары"],
  },
  9: {
    text: "В какой роли выступили гости?",
    options: [
      "Самарских художников",
      "Сотрудников Музея Модерна",
      "Арт-критиков",
      "Владельцев галереи",
    ],
  },
  10: {
    text: "Какая река протекает через Красную Поляну?",
    options: ["Кубань", "Мзымта", "Псоу", "Сочи"],
  },
  11: {
    text: "Какие животные живут в Горной Олимпийской деревне?",
    options: ["Ламы", "Леопарды", "Белки", "Альпаки"],
  },
  12: {
    text: "Как называется подъемник между Розой Долиной и Горной Олимпийской деревней?",
    options: ["Альпика", "Эдельвейс", "Олимпия", "Лаура"],
  },
  13: {
    text: "Почему курорт называется Роза Хутор?",
    options: [
      "В честь редких роз, растущих на склонах гор",
      "В честь местной жительницы",
      "В честь персонажа из легенды",
      "В честь эстонца Рооза",
    ],
  },
  14: {
    text: "Сколько было свечей на праздничном столе?",
    options: ["5", "7", "10", "Ни одной"],
  },
  15: {
    text: "Под что стилизовали здание ратуши на главной площади курорта Роза Хутор?",
    options: [
      "Под ЖД вокзал города Сочи",
      "Под Кремль и Красную площадь",
      "Под греческий Акрополь",
      "Под лондонский Биг Бен",
    ],
  },
  16: {
    text: "Какую максимальную скорость может развить родельбан в Горной Олимпийской деревне?",
    options: ["10 км/ч", "20 км/ч", "40 км/ч", "60 км/ч"],
  },
  17: {
    text: "Какой неинтересный музей можно посетить в Розе Долине?",
    options: [
      "Краснополянский художественный музей",
      "Музей археологии",
      "Музей высокогорных искусств",
      "Музей друзей",
    ],
  },
  18: {
    text: "Какой традиции не было на церемонии?",
    options: [
      "Открытие шампанского",
      "Бросание лепестков",
      "Горько!",
      "Обмен кольцами",
    ],
  },
  19: {
    text: "Как назывался ресторан, в котором мы вместе ужинали накануне свадьбы?",
    options: ["Груша", "Варенье", "Варежка", "Дичь"],
  },
  20: {
    text: "Какие цветы были в букете невесты?",
    options: ["Лаванда", "Пионы", "Гвоздики", "Ромашки"],
  },
  21: {
    text: "Почему курорт называется Красная поляна?",
    options: [
      "В честь красного октября",
      "Из-за папоротников",
      "Эту поляну считали самой красивой",
      "Здесь много растений из Красной книги",
    ],
  },
  22: {
    text: "Из какого сплава сделаны монеты?",
    options: ["Биллон", "Сталь", "Латунь", "Мельхиор"],
  },
  23: {
    text: "Какая гора была видна с места проведения церемонии?",
    options: ["Эльбрус", "Казбек", "Аибга", "Килиманджаро"],
  },
  24: {
    text: "Какого цвета была обувь у жениха?",
    options: ["Синий", "Чёрный", "Серый", "Винный"],
  },
};

export const answers: { [key: string]: string } = {
  1: "Фруктовый сад",
  2: "3 кг",
  3: "Осам",
  4: "Вилки",
  5: "Чайная роза",
  6: "Заказали на Озоне",
  7: "Пупок",
  8: "Из Томска",
  9: "Самарских художников",
  10: "Мзымта",
  11: "Альпаки",
  12: "Олимпия",
  13: "В честь эстонца Рооза",
  14: "Ни одной",
  15: "Под ЖД вокзал города Сочи",
  16: "40 км/ч",
  17: "Музей археологии",
  18: "Бросание лепестков",
  19: "Груша",
  20: "Гвоздики",
  21: "Из-за папоротников",
  22: "Мельхиор",
  23: "Аибга",
  24: "Винный",
};

export const introduction: string[] = [
  `Один из главных атрибутов свадьбы - фотографии. Их делают долго, все с
  нетерпением ждут результатов.`,
  `В главный альбом удалось собрать больше 120 фотографий: от
  фотографа, от гостей и с полароида.`,
  ``,
  `Но мы знаем, что ты любишь разгадывать загадки больше, чем смотреть на
  фотографии.`,
  `Специально для тебя Даша придумала 8 вопросов о нашем общем путешествии.`,
  `Ответив на них, ты откроешь доступ к альбому.`,
];

export const comments: { [key: string]: string } = {
  1: `Верно. Говорят, что на территории парка растет около 180 видов различных деревьев.`,
  2: `Идеальный вес для чеканки памятных монет. И для продавливания уложенной плитки...`,
  3: `Да уж. Спастись от них получилось только тогда, когда мяса не осталось.`,
  4: `По плану у кейтеринга должно быть 40 вилок, по факту оказалось ни одной. 
  Во время церемонии пришлось арендовать их в ближайшем ресторане. 
  Повезло, что эти 40 вилок всё же привезли позже.`,
  5: `Чайная, а не пудровая! Она легче и нежнее и в жизни, и web-e. А вот и hex-цвета: #EDBFC6`,
  6: `Пень на маркетплейсе оказалось найти легче, чем в лесу.`,
  7: `Пупок сложно нарисовать, еще сложнее понять, что нарисован пупок (.)`,
  8: `Оказалось, что это ближайший к Сочи город, где могут создать пресс.`,
  9: `Самарский минимализм, супрематизм или, может, кубизм. В любом случае можно открывать выставку.`,
  10: `Да, это самая длинная и полноводная река России из впадающих непосредственно в Чёрное море.`,
  11: `Традиционное место обитания альпак – перуанские Анды, но и здесь они прекрасно освоились.`,
  12: `Верно. Протяженность пути - более 2 300 м, а перепады высот достигают 610 метров.`,
  13: `В 1871 году 73 семьи решили переселиться из Эстонии на юг. 
  Дошли до Поволжья, Калмыкии и Черного моря. Свое название хутор получил от одного из первых 
  эстонских поселенцев – лесника Адула Рооза.`,
  14: `Свечи в декор мы решили не добавлять. Да и зачем нужны свечи на свадьбе?`,
  15: `Прототипом ратуши стала башня сочинского ЖД вокзала - памятника сталинского ампира.`,
  16: `Точно. 5 минут <как обещают> веселья на скорости 40 км/ч. Можно и не тормозить!`,
  17: `Даже Даше было очень скучно...`,
  18: `Сначала мы хотели бросать лепестки. И даже заказали искусственные. 
  Но из-за ветра и объемов отказались. Пришлось бы половину торжества ловить их по всей территории.`,
  19: `Заказать стол на большую компанию там получилось только со второй попытки. В Груше вкусная еда, 
  но ленивые администраторы.`,
  20: `Белые гвоздики хорошо дополнили основу из роз. А ещё в букете был эвкалипт.`,
  21: `Неожиданно, но это правда. На склонах гор осенью краснеют скумпия и папоротник-орляк.`,
  22: `Этот сплав из меди и никеля изобрели в 19 веке. Отличается высокой стойкостью к коррозии.
  В России особенно популярен в качестве металла для подстаканников и другой посуды в поездах.`,
  23: `Аибга – хребет, разделяющий среднюю часть долины Мзымты и верховья Псоу. 
  Высота центральной вершины – 2450 м.`,
  24: `Туфли выбирали специально под галстук и под цвет кнопок на этом сайте.`,
  special: `while True - пока есть Истина. Так в программировании обозначают бесконечный цикл. 
  Код внутри этого цикла будет выполняться всегда. На монете этот шифр расположен по кругу.
  Круг и кольцо - символы бесконечности.`,
};

export const congratulations: string[] = [
  `Ура! Все вопросы пройдены!`,
  `Можно смотреть фотографии, кликнув по кнопке ниже.`,
  `Для быстрого доступа наверху появилась кнопка "Фото".`,
];
